import React, { useState, useEffect } from "react";
import { Button, TextField, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

export default function ProductsToolbar({
  searchTerm,
  onSearchChange,
  onAddClick,
}) {
  const [text, setText] = useState(searchTerm);

  useEffect(() => {
    setText(searchTerm);
  }, [searchTerm]);

  return (
    <>
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        color="secondary"
        onClick={onAddClick}
        sx={{ "& .MuiButton-startIcon": { marginRight: 1 } }}
      >
        הוסף מוצר
      </Button>

      <TextField
        label="חיפוש מוצר"
        variant="outlined"
        fullWidth
        sx={{ my: 2 }}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onSearchChange(text);
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}